/**
 * User Session Types
 *
 * Single-device session enforcement + invalidation reasons surfaced to
 * the client when a session is revoked.
 */
import { z } from 'zod';
// =============================================================================
// Invalidation reason
// =============================================================================
export const SessionInvalidatedReasonSchema = z.enum([
    'new_device_login',
    'logout',
    'admin_revoke',
    'expired',
]);
// =============================================================================
// User session row
// =============================================================================
export const UserSessionSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string(),
    userId: z.string().uuid(),
    deviceId: z.string(),
    deviceName: z.string(),
    userAgent: z.string(),
    ipAddress: z.string(),
    workosSessionId: z.string().nullable(),
    geoCountry: z.string().nullable(),
    geoCity: z.string().nullable(),
    createdAt: z.string(),
    lastSeenAt: z.string(),
    invalidatedAt: z.string().nullable(),
    invalidatedReason: SessionInvalidatedReasonSchema.nullable(),
});
// =============================================================================
// Session invalidated error (returned by API when client's session is dead)
// =============================================================================
export const SessionInvalidatedErrorSchema = z.object({
    code: z.literal('SESSION_INVALIDATED'),
    reason: SessionInvalidatedReasonSchema,
});
